module.exports = __webpack_public_path__ + "img/4.0c8df7f1.svg";